import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import CheckIcon from '@mui/icons-material/Check'
import { Button } from '@mui/material'
import Hidden from '@mui/material/Hidden'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

interface INavigationProps {
  links: { url: string; title: string }[]
  title: string
}

const Navigation: React.FC<INavigationProps> = ({ title, links }) => {
  const location = useLocation()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const isActive = (pathname: string) => {
    return location.pathname
      .replace(/\//gm, '')
      .includes(pathname.replace(/\//gm, ''))
  }

  return (
    <>
      <Hidden smDown>
        <h2 className='font-semibold my-10 text-base'>{title}</h2>
        <ul className='list-none m-0 p-0 text-13 mb-20'>
          {links.map((link, idx) => (
            <li className='mb-5' key={idx}>
              <Link
                to={link.url}
                className={`no-underline ${
                  isActive(link.url) ? 'font-semibold' : ''
                }`}
              >
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </Hidden>
      <Hidden smUp>
        <div className='mb-20 relative'>
          <Button
            variant='outlined'
            aria-controls='simple-menu'
            aria-haspopup='true'
            onClick={handleClick}
            endIcon={<ArrowDropDownIcon fontSize='inherit' />}
            fullWidth
          >
            <span className='text-left flex-1 text-capitalize font-semibold text-lg'>
              {title}
            </span>
          </Button>
        </div>
        <Menu
          anchorEl={anchorEl}
          elevation={1}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            style: {
              width: '100%',
            },
          }}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {links.map((link, idx) => (
            <MenuItem
              key={idx}
              onClick={handleClose}
              component={Link}
              to={link.url}
              style={{
                minHeight: 40,
              }}
            >
              <span className='flex-1'>{link.title}</span>
              {isActive(link.url) && <CheckIcon fontSize='inherit' />}
            </MenuItem>
          ))}
        </Menu>
      </Hidden>
    </>
  )
}

export default Navigation
